//
import '@styles/global.css';
//
import '@maptiler/sdk/dist/maptiler-sdk.css';
import 'react-toastify/dist/ReactToastify.css';

import AgaveProvider from '@/components/providers/agave/agave-provider';
import AuthProvider from '@/components/providers/auth/auth-provider';
import { HttpProvider } from '@/components/providers/http/http-provider';
import { RouteManager } from '@/router-manager';
import theme from '@/styles/theme';
import { ThemeProvider } from '@mui/material/styles';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <AgaveProvider>
          <AuthProvider>
            <HttpProvider>
              <RouteManager />
            </HttpProvider>
          </AuthProvider>
          <ToastContainer theme={'colored'} />
        </AgaveProvider>
      </ThemeProvider>
    </BrowserRouter>
  </StrictMode>,
);
